import React from "react";
import MasterDetailLayout from "../../../components/layout/MasterDetailLayout";
import SupervisorCompactList from "../components/SupervisorCompactList";

const SupervisorAreaSplitView = () => <MasterDetailLayout list={<SupervisorCompactList />} />;

export default SupervisorAreaSplitView;
